
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Button  from '@mui/material/Button';
import LoadingButton from '@mui/lab/LoadingButton';
import style from './bmp-modal.module.css';

export default function BmpModal({modalInfo, setModalInfo, confirmAction, loading, plural, children}) {
    const handleCloseModal = () => {
        setModalInfo(prev => ({
            ...prev,
            active: false
        }));
    };
    
    return (
        <Modal
            open={modalInfo.active}
            onClose={handleCloseModal}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            >
            <Box className={style['modal-container']}>
                <Button className={style['close-btn']} onClick={handleCloseModal} aria-label="Close Modal"><CloseIcon aria-hidden="true" /></Button>
                
                <Box id="modal-modal-title">
                    {modalInfo.state === 'approve' ? (
                        <Typography variant="h6" component="h2" sx={{fontWeight: 700, mb: 2}}>You are about to approve this item{plural && 's'}. <br/> This will update the status to live. Confirm to approve?</Typography>
                    ) : (
                        <Typography variant="h6" component="h2" sx={{fontWeight: 700, mb: 2}}>You are about to reject this item{plural && 's'}, Confirm to reject?</Typography>
                    )}
                </Box>

                <Box id="modal-modal-description" sx={{maxHeight: '400px', overflowY: 'auto'}}>
                    {children}
                </Box>

                <Box className={style.tableActions}>
                    <Button 
                        onClick={handleCloseModal} 
                        variant="outlined" 
                        size="large"
                        disabled={loading}
                    >No</Button>
                    <LoadingButton 
                        onClick={confirmAction} 
                        variant="contained" 
                        loading={loading}
                        size="large"
                    >Yes</LoadingButton>
                </Box>
            </Box>
        </Modal>
    )
}